export const excludedTags = ["girl"];

export const shootingDates = {
  "1965": "1965 shooting session.",
  "1966": "1966 June 11 shooting session, negatives used for proofs.",
  "1973": "1973 July 1 shooting session.",
  "1974": "1974 July 14 shooting session.",
  "1976": "1976 August 22 shooting session.",
  "1985": "1985 August 22 shooting session.",
  "1990": "1990 September 8 shooting session.",
  "1995": "1995 August 20 and 21 shooting sessions.",
  "1997": "1997 September 14-16 shooting sessions.",
  "1998": "1998 August 9 shooting session.",
  "2007": "2007 June 6 shooting session."
};

export const DEFAULT_LOCATION = 0.42256;
export const DEFAULT_YEAR = 1985;

// Getty Mapbox account, for production
export const mapboxGlAccessToken =
  "pk.eyJ1IjoiZ2V0dHlzb2Z0d2FyZSIsImEiOiJjazl4OGZxeXAwOW03M2pwdmcxNjB0cnZnIn0.703LFyVrHL4wiEeI6JDGRQ";
export const mapboxGlStyle =
  "mapbox://styles/gettysoftware/ckeory8140tel19ldrvnwwld0";

// Stamen Mapbox account, for development only
/*
export const mapboxGlAccessToken =
  "pk.eyJ1Ijoic3RhbWVuIiwiYSI6IlpkZEtuS1EifQ.jiH_c9ShtBwtqH9RdG40mw";
export const mapboxGlStyle =
  "mapbox://styles/stamen/ck91vasvo06iv1io63o29jsmg/draft";
  */

export const googleAnalyticsId = "UA-8087223-1";
export const sentryId =
  "https://6d9577891b8540ac857f74ea24030e27@o294689.ingest.sentry.io/5454896";

export const getAssetPath = path => {
  return process.env.VUE_APP_STATIC_PATH + path;
};
